import React from "react";
import { Skeleton } from "@components/Skeleton/Skeleton";

interface IParagraphSkeletonProps {
  count?: number;
}

export const ParagraphSkeleton: React.FC<IParagraphSkeletonProps> = ({
  count = 3,
}) => (
  <div className="flex flex-col gap-5">
    {Array(count)
      .fill(0)
      .map((_, index) => (
        <div key={index} className="flex flex-col gap-3">
          <Skeleton className="w-[130px] text-sm" />
          <div className="flex flex-col gap-2">
            <Skeleton className="w-full text-xs" />
            <Skeleton className="w-[80%] text-xs" />
            <Skeleton className="w-[95%] text-xs " />
          </div>
        </div>
      ))}
  </div>
);
